let videoBackgroundPromise;

function loadVideoBackground() {
  if (!videoBackgroundPromise) {
    videoBackgroundPromise = import(new URL('video-background-core.js', import.meta.url).href);
  }

  return videoBackgroundPromise;
}

function loadIfVideoBackgroundExists() {
  if (document.querySelector('video-background-component')) loadVideoBackground();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadIfVideoBackgroundExists, { once: true });
} else {
  loadIfVideoBackgroundExists();
}
